import { render, staticRenderFns } from "./Sj_err.vue?vue&type=template&id=c67d4db6&scoped=true&"
import script from "./Sj_err.vue?vue&type=script&lang=js&"
export * from "./Sj_err.vue?vue&type=script&lang=js&"
import style0 from "./Sj_err.vue?vue&type=style&index=0&id=c67d4db6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c67d4db6",
  null
  
)

export default component.exports